import IconFind from "../../images/icon-find-pub.png";
import IconStay from "../../images/icon-stay.png";
import IconRun from "../../images/icon-run-pub.png";
import IconShop from "../../images/icon-shop.png";
import IconBasket from "../../images/icon-basket.png";
import IconFindGreen from "../../images/icon-find-pub-green.png";
import IconStayGreen from "../../images/icon-stay-green.png";
import IconRunGreen from "../../images/icon-run-pub-green.png";
import IconShopGreen from "../../images/icon-shop-green.png";
import IconBasketGreen from "../../images/icon-basket-green.png";

export default theme => ({
    topNav: {
        backgroundColor: theme.palette.secondary.main,
        padding: '20px 24px',
        [theme.breakpoints.up('md')]: {
            padding: '24px 40px',
            backgroundColor: theme.palette.background.default,
            borderBottom: '2px solid',
            borderColor: theme.palette.common.black,
        },
        '& *': {
            opacity: 1,
        },
        '&[open] *': {
            opacity: 0,
        },
        '&::after': {
            content: '""',
            display: 'table',
            clear: 'both',
        },
        '& .site-logo': {
            display: 'inline-block',
            textAlign: 'center',
            '& img': {
                maxHeight: 20,
                [theme.breakpoints.up('md')]: {
                    maxHeight: 34,
                },
                '&.desktop-logo': {
                    display: 'none',
                    [theme.breakpoints.up('md')]: {
                        display: 'block',
                    }
                },
                '&.mobile-logo': {
                    [theme.breakpoints.up('md')]: {
                        display: 'none',
                    }
                }
            },
        },
        '& nav': {
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            minHeight: 0,
            zIndex: 100,
            backgroundColor: theme.palette.background.default,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '10px 5px',
            boxShadow: '0 -16px 16px rgba(0,0,0,0.3)',
            [theme.breakpoints.up('md')]: {
                position: 'relative',
                maxWidth: 'calc(100% - 180px)',
                float: 'right',
                boxShadow: 'none',
                width: 860,
                padding: 0,
            },
            '& a': {
                fontSize: 8,
                fontFamily: theme.headerFont,
                color: theme.palette.common.black,
                textDecoration: 'none',
                textTransform: 'uppercase',
                transition: 'opacity 250ms ease-in-out',
                opacity: 1,
                display: 'inline-block',
                lineHeight: '1.2',
                fontWeight: '600',
                letterSpacing: '0.03em',
                textAlign: 'center',
                flex: '0 0 20%',
                [theme.breakpoints.up('md')]: {
                    fontSize: 18,
                    letterSpacing: '0.068em',
                    flex: '1 0 auto',
                    textAlign: 'right',
                    
                },
                '&[aria-current="page"]:not(.basket)': {
                    '& span': {
                        position: 'relative',
                        '&::after': {
                            content: '""',
                            height: 2,
                            backgroundColor: theme.palette.primary.main,
                            display: 'block',
                            position: 'absolute',
                            bottom: -3,
                            left: 0,
                            right: 0,
                        }
                    }
                },
                '&:hover, &:focus': {
                    color: '#72ce9b',
                },
                '&::before':{
                    width: 32,
                    height: 32,
                    content: '""',
                    margin: '0 auto 5px',
                    display: 'block',
                    backgroundPosition: 'center',
                    backgroundSize: 'contain',
                    [theme.breakpoints.up('md')]: {
                        display: 'inline-block',
                        margin: '0 10px 0 0',
                        verticalAlign: 'text-bottom',
                    }
                },
                '&.find-a-pub': {
                    '&::before': { 
                        backgroundImage: 'url(' + IconFind + ')' 
                    },
                    '&:hover, &:focus': {
                        '&::before': { 
                            backgroundImage: 'url(' + IconFindGreen + ')' 
                        },
                    }
                },
                '&.stay-with-us': {
                    '&::before': { 
                        backgroundImage: 'url(' + IconStay + ')' 
                    },
                    '&:hover, &:focus': {
                        '&::before': { 
                            backgroundImage: 'url(' + IconStayGreen + ')' 
                        },
                    }
                },
                '&.run-a-pub': {
                    '&::before': { 
                        backgroundImage: 'url(' + IconRun + ')' 
                    },
                    '&:hover, &:focus': {
                        '&::before': { 
                            backgroundImage: 'url(' + IconRunGreen + ')' 
                        },
                    }
                },
                '&.shop': {
                    '&::before': { 
                        backgroundImage: 'url(' + IconShop + ')' 
                    },
                    '&:hover, &:focus': {
                        '&::before': { 
                            backgroundImage: 'url(' + IconShopGreen + ')' 
                        },
                    }
                },
                '&.basket': {
                    position: 'relative',
                    [theme.breakpoints.up('md')]: {
                        flex: '0 0 32px',
                        fontSize: 0,
                        '&::before': {
                            margin: 0,
                        }
                    },
                    '& span': {
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText,
                        borderRadius: '50%',
                        width: 20,
                        height: 20,
                        border: '2px solid',
                        borderColor: theme.palette.background.default,
                        position: 'absolute',
                        top: 0,
                        left: 'calc(50% + 5px)',
                        lineHeight: '16px',
                        textAlign: 'center',
                        fontSize: 8,
                    },
                    '&::before': { 
                        backgroundImage: 'url(' + IconBasket + ')' 
                    },
                    '&:hover, &:focus': {
                        '&::before': { 
                            backgroundImage: 'url(' + IconBasketGreen + ')' 
                        },
                    }
                }
            }
        },
        '& .open-menu': {
            float: 'right',
            color: theme.palette.secondary.contrastText,
            fontSize: 12,
            letterSpacing: '0.068em',
            lineHeight: '20px',
            padding: 0,
            [theme.breakpoints.up('md')]: {
                display: 'none',
            },
            '& .MuiButton-label': {
                '& span': {
                    display: 'block',
                    position: 'relative',
                    height: 3,
                    backgroundColor: theme.palette.secondary.contrastText,
                    borderRadius: 2,
                    width: 25,
                    margin: '0 0 0 5px',
                    transition: 'width 250ms ease-in-out, margin-left 250ms ease-in-out',
                    [theme.breakpoints.up('lg')]: {
                        transform: 'scale(0.6)',
                        margin: '-4px 0 0 14px',
                    },
                    '&::after, &::before': {
                        content: '""',
                        backgroundColor: theme.palette.secondary.contrastText,
                        position: 'absolute',
                        height: 3,
                        borderRadius: 2,
                        transition: 'width 250ms ease-in-out',
                        right: 0,
                    },
                    '&::after': {
                        width: 25,
                        top: 7,
                    },
                    '&::before': {
                        width: 25,
                        bottom: 7
                    }
                }
            },
            '&:hover, &:focus': {
                '& .MuiButton-label span': {
                    width: 25,
                    [theme.breakpoints.up('lg')]: {
                        marginLeft: 6,
                    },
                    '&::before, &::after': {
                        width: 25,
                    }
                }
            }
        }
    },
    fullNav: {
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 100,
        display: 'none',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        '&[open]': {
            display: 'block',
        },
        '& .overlay': {
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: '' + theme.palette.secondary.main,
            padding: '20px 24px',
            overflow: 'scroll',
            [theme.breakpoints.up('md')]: {
                padding: 70,
                overflow: 'hidden',
            },
            '& .close-menu': {
                color: theme.palette.secondary.contrastText,
                fontSize: 12,
                letterSpacing: '0.068em',
                lineHeight: 1.5,
                margin: '0 0 30px auto',
                display: 'block',
                verticalAlign: 'middle',
                float: 'right',
                padding: 0,
                '& .MuiButton-label': {
                    '& span': {
                        backgroundColor: theme.palette.secondary.contrastText,
                        width: 18,
                        height: 18,
                        clipPath: 'polygon(0 10%, 40% 50%, 0 90%, 10% 100%, 50% 60%, 90% 100%, 100% 90%, 60% 50%, 100% 10%, 90% 0, 50% 40%, 10% 0%)',
                        display: 'inline-block',
                        verticalAlign: 'text-top',
                    }
                },
                [theme.breakpoints.up('md')]: {
                    float: 'right',
                }
            },
            '& .site-logo': {
                display: 'inline-block',
                margin: '0 0 40px',
                float: 'left',
                '& img': {
                    maxHeight: 20,
                    '&.desktop-logo': {
                        display: 'none',
                    }
                },
            },
            '& .nav-wrapper': {
                clear: 'both',
                maxWidth: 320,
                margin: '0 auto',
            },
            '& nav.main-nav-stacked': {
                flexDirection: 'column',
                [theme.breakpoints.up('md')]: {
                    alignItems: 'flex-start',
                },
                '& a': {
                    fontFamily: theme.headerFont,
                    color: theme.palette.common.black,
                    fontSize: 18,
                    lineHeight: '32px',
                    textDecoration: 'none',
                    marginBottom: 8,
                    letterSpacing: '0.064em',
                    display: 'block',
                    backgroundColor: theme.palette.background.default,
                    padding: 16,
                    textTransform: 'uppercase',
                    width: '100%',
                    '&:hover, &:focus': {
                        color: '#72ce9b',
                    },
                    '&::before':{
                        width: 32,
                        height: 32,
                        content: '""',
                        margin: '0 24px 0 0',
                        display: 'inline-block',
                        backgroundPosition: 'center',
                        backgroundSize: 'contain',
                        verticalAlign: 'bottom',
                    },
                    '&.find-a-pub': {
                        '&::before': { 
                            backgroundImage: 'url(' + IconFind + ')' 
                        },
                        '&:hover, &:focus': {
                            '&::before': { 
                                backgroundImage: 'url(' + IconFindGreen + ')' 
                            },
                        }
                    },
                    '&.stay-with-us': {
                        '&::before': { 
                            backgroundImage: 'url(' + IconStay + ')' 
                        },
                        '&:hover, &:focus': {
                            '&::before': { 
                                backgroundImage: 'url(' + IconStayGreen + ')' 
                            },
                        }
                    },
                    '&.run-a-pub': {
                        '&::before': { 
                            backgroundImage: 'url(' + IconRun + ')' 
                        },
                        '&:hover, &:focus': {
                            '&::before': { 
                                backgroundImage: 'url(' + IconRunGreen + ')' 
                            },
                        }
                    },
                    '&.shop': {
                        '&::before': { 
                            backgroundImage: 'url(' + IconShop + ')' 
                        },
                        '&:hover, &:focus': {
                            '&::before': { 
                                backgroundImage: 'url(' + IconShopGreen + ')' 
                            },
                        }
                    },
                    '&.basket': {
                        position: 'relative',
                        '& span': {
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText,
                            borderRadius: '50%',
                            width: 20,
                            height: 20,
                            border: '2px solid',
                            borderColor: theme.palette.background.default,
                            position: 'absolute',
                            top: 12,
                            left: 38,
                            fontSize: 9,
                            lineHeight: '16px',
                            textAlign: 'center',
                        },
                        '&::before': { 
                            backgroundImage: 'url(' + IconBasket + ')' 
                        },
                        '&:hover, &:focus': {
                            '&::before': { 
                                backgroundImage: 'url(' + IconBasketGreen + ')' 
                            },
                        }
                    }
                }
            },
            '& .house-data': {
                borderColor: theme.palette.secondary.contrastText,
                marginTop: 35,
                paddingTop: 30,
            },
            '& .rob-family': {
                textAlign: 'center',
                display: 'none',
                '& img': {
                    width: 205,
                    margin: '0 auto',
                },
                '&.mob': {
                    display: 'block',
                    [theme.breakpoints.up('md')]: {
                        display: 'none',
                    }
                }
            }
        }
    },
    topNavTheme: {
        ...theme.topNavTheme,
    }
})